<template>
  <dashboard-overview />
</template>

<script>
import store from '@/store';
import dashboardOverview from '@/views/app/overview';

export default {
  async beforeRouteEnter(to, from, next) {
    return Promise.all([
      store.dispatch('fetchAccount'),
    ])
      .then(next);
  },
  components: { 'dashboard-overview': dashboardOverview },
};
</script>
